import { useCallback, useState } from 'react';
import { useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getLoginWithSsoKey } from '../../utils/keys';
export const useLoginWithSso = (options) => {
    const { useQueryOptions } = options || {};
    const queryClient = useQueryClient();
    const { client } = useTribeClient();
    const [isLoading, setLoading] = useState(false);
    const loginWithSsoKey = getLoginWithSsoKey();
    const login = useCallback(async (variables) => {
        setLoading(true);
        const data = await queryClient.fetchQuery(loginWithSsoKey, () => client === null || client === void 0 ? void 0 : client.auth.ssoUrl(variables), useQueryOptions);
        setLoading(false);
        return data;
    }, [loginWithSsoKey, client === null || client === void 0 ? void 0 : client.auth, queryClient, useQueryOptions]);
    return {
        login,
        isLoading,
    };
};
//# sourceMappingURL=useLoginWithSso.js.map